import * as jQuery from "jquery";
import { StyleClass } from "../../../../presentation/Shared/Styles/CSS";
import {
    LoadStoredQuickJournalThemeName,
    ResolveQuickJournalThemeName,
    type QuickJournalThemeSelectionName,
} from "source/app/presentation/BottomBar/QuickJournal/View/QuickJournalTheme";
import { ArrayUtils } from "source/app/services/ArrayUtils";
import { GetPreferredTexture } from "source/app/services/UI/Background/Texture/PreferredTextures";

declare const WALLPAPER_FILE_NAMES: Record<WallpaperTheme, string[]>;

type WallpaperTheme = "light" | "dark";

export class DesktopImage {
    constructor(readonly backgroundClass: string) {}

    Show() {
        const currentClassName = jQuery("html").attr("class");

        if (currentClassName !== this.backgroundClass) {
            jQuery("html")
                .removeClass(currentClassName)
                .addClass(this.backgroundClass);
        }
    }
}

const desktopInitial = new DesktopImage(
    StyleClass(`desktop`, {
        background:
            "linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(/images/backgrounds/0.jpg) no-repeat center center fixed",
        backgroundColor: "black",
        height: "100%",
        backgroundSize: "cover",
    })
);

const GetWallpaperTheme = (
    themeName?: QuickJournalThemeSelectionName
): WallpaperTheme => {
    const resolvedThemeName = ResolveQuickJournalThemeName(
        themeName ?? LoadStoredQuickJournalThemeName()
    );

    return resolvedThemeName === "dune" ? "light" : "dark";
};

const GetWallpaperFileNames = (wallpaperTheme: WallpaperTheme) => {
    if (typeof WALLPAPER_FILE_NAMES === "undefined") {
        return [];
    }

    return WALLPAPER_FILE_NAMES[wallpaperTheme] ?? [];
};

const GetRandomFullSizeBackground = (
    themeName?: QuickJournalThemeSelectionName
) => {
    const wallpaperTheme = GetWallpaperTheme(themeName);
    const fileName = ArrayUtils.GetRandomElement(
        GetWallpaperFileNames(wallpaperTheme)
    );
    if (!fileName) {
        return mobileInitial;
    }

    const imagePath = `/images/backgrounds/${wallpaperTheme}/${fileName}`;

    return new DesktopImage(
        StyleClass(`bkg_${wallpaperTheme}_${fileName}`, {
            background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${imagePath})`,
            backgroundColor: "black",
            height: "100%",
            backgroundSize: `cover`,
            backgroundPosition: `center center`,
            backgroundAttachment: `fixed`,
            backgroundRepeat: `no-repeat`,
        })
    );
};

const mobileInitial = new DesktopImage(
    StyleClass(`mobile`, {
        background:
            "linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(/images/backgrounds/0.jpg) center center",
        backgroundColor: "black",
        height: "100%",
    })
);

const transcendent = new DesktopImage(
    StyleClass(`transcendent`, {
        background: 'url("/images/backgrounds/diagmonds.png")',
        backgroundColor: "darkgoldenrod",
        height: "100%",
    })
);

const transcendent2 = new DesktopImage(
    StyleClass(`transcendent2`, {
        background: 'url("/images/backgrounds/gold-tile.png")',
        backgroundColor: "#bf8000",
        height: "100%",
    })
);

const RandomPreferred = () => GetPreferredTexture();

export const desktopBackgroundImages = {
    desktopInitial,
    GetRandomFullSizeBackground,
    mobileInitial,
    transcendent,
    transcendent2,
    RandomPreferred,
};
